/**
 * The business-type switcher on the studio page. Same product, different
 * words — a visitor should see their own business on the page.
 *
 * Salons have their own page now (/salons, content in landings/salons.js),
 * so the switcher here shows the studio and a chip linking across. Studios
 * run אימונים, salons run תורים — each page speaks its own audience's words.
 */

export const industries = [
  {
    id: "fitness",
    label: "פילאטיס, יוגה, ספינינג וחדר כושר",
    headline: "שיעור מלא, בלי רשימות בנייר",
    text: "מספר מקומות מוגבל לכל שיעור, הרשמה עצמאית של המתאמנות, ורשימת המתנה שממלאת כל ביטול.",
    image: require("@/assets/fitness-screen.jpg"),
    imageAlt: "מסך הבית של אפליקציית אפלאטס לסטודיו אימונים",
    highlights: [
      "מקומות מוגבלים לשיעור",
      "כרטיסיות ומנויים",
      "מדידות ומעקב התקדמות",
    ],
  },
];
